import { Pagination } from "services/search";
import { PaginationDirection } from "services/url";
import { DropdownOption } from "ui/components/Dropdown/Dropdown/types";
import { BadgeProps } from "ui/components/Badge/types";

import {
  CronJobExecutionLogSearchFormValues,
  CronJobExecutionSearchFormValues,
  CronJobExecutionStatus,
  CronJobStatus,
} from "./types";

export const initialCronJobExecutionSearchForm: CronJobExecutionSearchFormValues = {
  status: "",
};

export const initialCronJobExecutionLogSearchForm: CronJobExecutionLogSearchFormValues = {
  search: "",
};

/** Obrade: najnovija prva. Backend sortira po `started`. */
export const initialCronJobExecutionPagination: Pagination = {
  pageNumber: 1,
  pageSize: 20,
  sort: { sortBy: "started", direction: PaginationDirection.Descending },
  totalCount: 0,
  totalPages: 0,
};

/** Log obrade: kronološki, kako je obrada pisala. Veća stranica jer su zapisi kratki redci. */
export const initialCronJobExecutionLogPagination: Pagination = {
  pageNumber: 1,
  pageSize: 50,
  sort: { sortBy: "id", direction: PaginationDirection.Ascending },
  totalCount: 0,
  totalPages: 0,
};

export const CRON_JOB_STATUS_LABELS: Record<CronJobStatus, string> = {
  running: "U tijeku",
  finished: "Završena",
  error: "Greška",
  inactive: "Neaktivna",
};

export const CRON_JOB_STATUS_VARIANTS: Record<CronJobStatus, BadgeProps["variant"]> = {
  running: "info",
  finished: "success",
  error: "danger",
  inactive: "secondary",
};

export const CRON_JOB_EXECUTION_STATUS_LABELS: Record<CronJobExecutionStatus, string> = {
  running: "U tijeku",
  finished: "Završena",
  error: "Greška",
  aborted: "Prekinuta",
};

export const CRON_JOB_EXECUTION_STATUS_VARIANTS: Record<
  CronJobExecutionStatus,
  BadgeProps["variant"]
> = {
  running: "info",
  finished: "success",
  error: "danger",
  aborted: "warning",
};

export const CRON_JOB_EXECUTION_STATUS_OPTIONS: DropdownOption[] = (
  Object.keys(CRON_JOB_EXECUTION_STATUS_LABELS) as CronJobExecutionStatus[]
).map((status) => ({
  value: status,
  text: CRON_JOB_EXECUTION_STATUS_LABELS[status],
}));
